// extracted by mini-css-extract-plugin
module.exports = {"container":"e_-Q","icon":"e_aR","pathBg":"e_bR","pathFg":"e_cR","variantViolet":"e_dR","variantBase":"e_eR"};